<template>
  <!-- 抽奖活动入口，只放在游戏商城详情页 -->
  <main class="activity_notice_body">
    <move-animation>
      <section
        v-if="showEntry"
        :class="['activity_notice_wrapper', gameName, displayModeClassName]"
        @click="handleGoToLuckyDraw"
        :style="{ backgroundImage: `url(${entryImgSrc})` }"
      ></section>
    </move-animation>
    <van-popup
      class="luckydraw-popup"
      v-model="showLuckydrawPopup"
      closeable
      get-container=".activity_notice_body"
      :overlay-style="{ zIndex: 1 }"
      :style="{ height: popupHeight }"
    >
      <lucky-draw
        :openFrom="'popup'"
        ref="luckyDraw"
        source="detailPage"
        @handleClose="handleClose"
      />
    </van-popup>
  </main>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import LuckyDraw from '@/pages/Activity/LuckyDraw/'
  import MoveAnimation from '@/components/MoveAnimation'
  import {
    trackActivityEntryShow,
    trackActivityEntryClick,
  } from '@/pages/Activity/firebase'
  import luckydrawMixin from '@/mixins/activity/luckydraw.js'
  import { getSecondLevelTimestamp } from '@/utils/timeFormat'
  import { imgLoadedHandler } from '@/utils/image.js'
  import { getUvid } from '@/utils/uvid'
  import { getQuery } from '@/utils/utils'
  import bus from '@/utils/bus'
  import { storage } from '@/utils/storage'
  import { isHeightLessThan750 } from '@/utils/platform.js'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'

  export default {
    name: 'activity-notice',
    mixins: [luckydrawMixin],
    components: {
      LuckyDraw,
      MoveAnimation,
    },
    data() {
      return {
        showLuckydrawPopup: false,
        startTimestamp: 0,
        endTimestamp: 0,
        currTimestamp: Math.floor(new Date().getTime() / 1000), // 秒级时间戳，与接口返回保持一致,
        entryImgSrc: '',
        activityId: '',
        uvid: getUvid(),
        isHighestPriority: false, // 标记是否为当前游戏的活动最高优先级
      }
    },
    computed: {
      ...mapState(['gameName', 'isApp', 'isTurbo', 'region', 'userInfo']),
      ...mapGetters(['displayModeClassName']),
      showEntry() {
        // a/b Test: uvid 末尾数字为偶数不展示，其它情况展示：尾数为奇数或者非数字，uvid 为空
        // const lastChar = getUvid().slice(-1)
        // const abTest = getUvid() === 'anonymous' || lastChar % 2 === 1
        return (
          this.isHighestPriority && !this.isOver && !this.showLuckydrawPopup
        )
      },
      isOver() {
        return (
          (this.startTimestamp === 0 && this.endTimestamp === 0) ||
          this.currTimestamp > this.endTimestamp ||
          this.currTimestamp < this.startTimestamp
        )
      },
      popupHeight() {
        return this.isTurbo ? '75%' : isHeightLessThan750() ? '80%' : 'auto'
      },
    },
    watch: {
      userInfo(val) {
        if (val && val.kicoinId) {
          // 如果登录了就直接查询通用活动接口（不管是否存在优惠券活动，因为登录后的优惠券弹窗不存在活动入口）
          this.queryActivityList()
        }
      },
      showEntry(val) {
        if (val) {
          pagePopupShow({
            page: this.gameName || 'home',
            act_id: this.activityId, // 活动编号
            popup_type: 'toast',
          })
        }
      },
      showLuckydrawPopup(val) {
        if (val) {
          pagePopupShow({
            page: this.gameName || 'home',
            act_id: this.activityId, // 活动编号
            popup_type: 'popup',
          })
        }
      },
    },
    mounted() {
      if (storage.get('autoOpenDrawPopup') === '1') {
        this.showLuckydrawPopup = true
        storage.set('autoOpenDrawPopup', 0)
      }
      if (this.userInfo && this.userInfo.kicoinId) {
        // 如果登录了就直接查询通用活动接口（不管是否存在优惠券活动，因为登录后的优惠券弹窗不存在活动入口）
        this.queryActivityList()
      } else {
        bus.$on('existCouponActivity', (res) => {
          // 如果存在优惠券活动则不请求抽奖活动
          if (res) return
          this.queryActivityList()
        })
      }
    },
    beforeDestroy() {
      bus.$off('existCouponActivity')
    },
    methods: {
      ...mapMutations(['setLuckyDrawInfo']),
      handleClose() {
        this.showLuckydrawPopup = false
      },
      handleGoToLuckyDraw() {
        // 从详情页点击活动入口打开活动弹窗
        trackActivityEntryClick({
          page: this.gameName,
          act_id: this.activityId,
        })
        pagePopupClick({
          page: this.gameName,
          act_id: this.activityId,
        })
        this.showLuckydrawPopup = true
      },
      queryActivityList() {
        // queryOnline	0:查询所有状态的活动 1:只查询在线活动
        // 不传 activityType 则查询所有活动
        const activitySource = getQuery('activitySource')
        const source = getQuery('source')
        this.getActivityInfos({
          queryOnline: 1,
          activityType: '',
          activitySource: activitySource || source, //优先取 activitySource
        }).then((res) => {
          if (res && res.activityId) {
            this.activityId = res.activityId
            this.isHighestPriority = res.activityType * 1 === 2
            this.setLuckyDrawInfo(res)
            // 秒级时间戳
            this.startTimestamp = getSecondLevelTimestamp(res.startTime || 0)
            this.endTimestamp = getSecondLevelTimestamp(res.endTime || 0)
            imgLoadedHandler(
              res.extraInfo.notLoginTipPic,
              require('@/assets/images/activities/luckydraw/activity_entry.png')
            ).then((res) => {
              this.entryImgSrc = res
            })
            this.showEntry &&
              trackActivityEntryShow({
                page: this.gameName,
                act_id: this.activityId,
              })
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .activity_notice_wrapper {
    width: 540px;
    height: 244px;
    font: 400 42px/47px 'Noto Sans';
    color: #fff;
    display: flex;
    justify-content: center;
    line-height: 35px;
    border-radius: 60px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    &.display-game-turbo {
      bottom: 320px;
    }
    &.hide {
      display: none;
    }
    .desc {
      font: 700 42px/42px 'Noto Sans';
      margin-top: 156px;
      margin-left: 76px;
      color: #ffff81;
    }
    .coutdown_wrapper {
      margin-left: 30px;
      margin-right: 30px;
      .van-count-down {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: #fff;

        & > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 67px;
          width: 50px;
          padding-top: 10px;

          span.square {
            display: inline-block;
            width: 40px;
            height: 37px;
            background: #f35b33;
            border-radius: 2px;
            font-size: 30px;
            text-align: center;
            line-height: 37px;
          }
          p {
            height: 30px;
            font-size: 12px;
            text-align: center;
            line-height: 30px;
          }
        }
      }
    }
    &.display-game-turbo {
      width: 450px;
      height: 320px;
      .desc {
        font-size: 20px;
        margin-top: 182px;
      }
    }
  }

  .activity_notice_body {
    .luckydraw-popup {
      z-index: 5 !important; // 使得登录面板显示在抽奖弹窗上方
      border: 2px solid #814bfe;
      border-radius: 20px;
    }
  }
</style>
